<template>
  <px-custom-dialog transition="fadet"
                    width="500"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Usuário
    </template>
    <template>
      <div class="text--primary" v-if="user">
        <v-row>
          <v-col cols="12">
            <span class="caption font-weight-bold">Nome</span>
            <div>
              {{ user.nome }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span class="caption font-weight-bold">E-mail</span>
            <div>
              {{ user.email }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <span class="caption font-weight-bold">CPF</span>
            <div>
              {{ user.cpf | cpf }}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-switch
              v-model="user.enabled"
              label="Usuário ativo"
            ></v-switch>
          </v-col>
        </v-row>
      </div>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             :loading="loading"
             @click="save">
        Salvar
      </v-btn>
      <v-btn @click="close">
        Fechar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { clone } from 'lodash';
import UserService from '@/modules/usuarios/usuario-service';

export default {
  props: {
    usuario: Object,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      user: null,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    buildPayload() {
      return {
        id: this.user.id,
        enabled: this.user.enabled,
      };
    },
    save() {
      this.loading = true;
      UserService.inativar(this.user.id, this.buildPayload())
        .then(() => {
          this.$toast('Usuário salvo', { color: 'success' });
          this.$emit('update');
          this.close();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.user = null;
        return;
      }
      if (this.usuario) {
        this.user = clone(this.usuario);
      }
    },
  },
};
</script>
